export const FORMATTER_STYLE = {
  floatFractionDigit3: 'float-fd-3',
  floatFractionDigit2: 'float-fd-2',
  floatFractionDigit6: 'float-fd-6',
  decimal: 'decimal',
};

let formatterDict = {};

export const setFormatter = (name, func) => {
  formatterDict[name] = func;
};

export const getFormatter = type => {
  return formatterDict[type] ? formatterDict[type] : value => value;
};

setFormatter(FORMATTER_STYLE.floatFractionDigit6, value =>
  value.toLocaleString('decimal', {
    maximumFractionDigits: 6,
    minimumFractionDigits: 6,
  }),
);

setFormatter(FORMATTER_STYLE.floatFractionDigit3, value =>
  value.toLocaleString('decimal', {
    maximumFractionDigits: 3,
    minimumFractionDigits: 3,
  }),
);

setFormatter(FORMATTER_STYLE.floatFractionDigit2, value =>
  value.toLocaleString('decimal', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }),
);

setFormatter(FORMATTER_STYLE.decimal, value =>
  value.toLocaleString('decimal', {
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }),
);



// WEBPACK FOOTER //
// ./src/utils/formatter.js